import React from 'react';
import BaseLink from './private/BaseLink';

/**
 * UnstyledLink
 * @param {LinkProps} props - props for link
 * @returns {JSX.Element} UnstyledLink
 */
function UnstyledLink({
    href,
    className,
    children,
    onClick,
    beforeClick,
    target,
    rel,
    title,
    tabIndex,
    'data-test': dataTest,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    'aria-describedby': ariaDescribedby,
}) {
    return (
        <BaseLink
            href={href}
            className={className}
            children={children}
            onClick={onClick}
            beforeClick={beforeClick}
            target={target}
            rel={rel}
            title={title}
            tabIndex={tabIndex}
            data-test={dataTest}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledby}
            aria-describedby={ariaDescribedby}
        />
    );
}

export default UnstyledLink;
